export const refuse = [
  {
    "title": "",
    "url": "domestic/negligence/2022_05_18 LEWISON ORDER-1.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_05_18 LEWISON ORDER-2.jpg"
  }
];
